import React, { useState, useEffect, useRef, Fragment } from "react";
import { Link } from "react-router-dom";

import { Container, Row, Col, Button } from "reactstrap";

// core components
import PageHeader from "components/Sections/PageHeader";
import GetStarted from "components/Sections/GetStarted";
import AppNavbar from "components/Navbars/AppNavbar";
import SimpleFooter from "components/Footers/SimpleFooter";

export default function Overview(props) {

    const mainEl = useRef(null);

    useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        mainEl.current.scrollTop = 0;

        document.title = "Club Apps | A Brief Overview"
        document.querySelector('meta[name="description"]').setAttribute("content", "Built from the ground up around clubs and organizations, we focus on giving administrators the tools to succeed without overcomplicating the process. Members and guests are presented with a simple yet intuitive interface that promotes engagement and long term use.");
    }, []);

    return (
        <Fragment>
            <AppNavbar white />
            <main ref={mainEl}>
                <section>
                    <Container>
                        <Row className="row-grid align-items-center">
                            <Col md="12" className="sub-nav pb-3">
                                <Link className="link text-default mr-3" to="/overview">
                                    OVERVIEW
                                </Link>
                                <Link className="link text-primary mr-3" to="/features">
                                    FEATURES
                                </Link>
                                <Link className="link text-primary" to="/pricing">
                                    PRICING
                                </Link>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <section>
                    <Container className="pb-5">
                        <Row className="row-grid align-items-center">
                            <Col className="" md="6">
                                <div className="pt-md-5">
                                    <h1>
                                        Built from the ground up around clubs and organizations
                                    </h1>
                                    <p className="lead text-muted">
                                        We focus on giving administrators the tools to succeed without overcomplicating the process. Members and guests are presented with a simple yet intuitive interface that promotes engagement and long term use.
                                    </p>

                                </div>
                            </Col>
                            <Col className="" md="6">

                                <img
                                    alt="Built around Clubs and Organizations"
                                    className="img-fluid"
                                    src={require("assets/images/product-overview.jpg")}
                                />

                            </Col>
                        </Row>
                    </Container>
                </section>
                <GetStarted />
            </main>
            <SimpleFooter/>
        </Fragment>
    )
}
